module.exports = __webpack_public_path__ + "static/media/page-header22.fc5e0cf2.jpg";